"use client";

import { Card, Stack, Text } from "@forestsync/ui";
import Link from "next/link";
import { TbChartBar } from "react-icons/tb";
import { useTranslations } from "next-intl";

interface ExploreCardProps {
  projectCount?: number;
}

export function ExploreCard({ projectCount }: ExploreCardProps) {
  const t = useTranslations("landing");

  return (
    <Card
      key="explore"
      withBorder
      shadow="sm"
      radius="md"
      padding="xl"
      component={Link}
      href="/market"
      h={240}
      display="flex"
      className="group transition-all duration-200 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <Stack align="center" justify="center" h="100%" w="100%" gap="xs">
        <TbChartBar size={40} color="var(--mantine-primary-color-filled)" />
        <Text fw={700} size="lg" ta="center" c="var(--mantine-color-text)">
          {t("viewAllMarkets")}
        </Text>
        {projectCount != null && projectCount > 0 && (
          <Text size="xs" c="dimmed" ta="center">
            {projectCount} {t("projectsLivePricing")}
          </Text>
        )}
      </Stack>
    </Card>
  );
}
